import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DetailIcon from '@mui/icons-material/Details';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData, fetchData1 } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Info as InfoIcon,

} from '@mui/icons-material';

function AdministrationIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();

    // useEffect(() => {
    //     // Check if the token is expired
    //     if (isAuthenticated && tokenIsExpired(token)) {
    //         // Token is expired, log out the user
    //         logout();
    //         return;
    //     }

    // }, [isAuthenticated, clubId, branchId, token, logout]);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();

    }, [isAuthenticated, clubId, branchId, token, logout]);

    const hasCreateAdministrationPermission = permissions.includes('Create Administration');
    const hasEditAdministrationPermission = permissions.includes('Edit Administration');
    const hasDeleteAdministrationPermission = permissions.includes('Delete Administration');
    useEffect(() => {
        fetchtableData();
    }, []);


    // const fetchtableData = async () => {

    //     fetchData('UserApi', `/${companyId}`, token)
    //         .then((response) => {
    //             if (response.responseCode == '1111') {
    //                 console.log(response);
    //                 setData(response.response_data);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching User Details:', error);
    //         });


    // };
    const fetchtableData = async () => {
        try {
            // Construct params1 and params2
            const params1 = `/${clubId}`;
            const params2 = `?branchId=${branchId}`;

            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);

            if (response.responseCode === '1111') {
                console.log(response);
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching table data:', error);
        }
    };


    const handleDelete = async () => {
        deleteData('UserApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });

    };

    const handleActivate = (itemId) => {
        activateData('UserApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '98%' }}>
            <div className='w-full mb-2 flex'>

                <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    USER</h6>



            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>First Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>Last Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>Email</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>Phone</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>Position</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #F5F5F5', fontSize: '12px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map(member => (

                                <TableRow key={member.id} className={member.isActive ? '' : 'inactiveRow'}>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.firstName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.lastName}</TableCell>

                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.email}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.phoneNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px' }}>{member.usertypes}</TableCell>

                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '3px', textAlign: 'right' }}>

                                        <Link to={`/AdministrationDetail/${member.id}`}>
                                            <IconButton>
                                                <DetailIcon style={{ color: 'darkgoldenrod' }} />
                                            </IconButton>
                                        </Link>

                                        {hasEditAdministrationPermission && (
                                            <Link to={`/userEdit/${member.id}`}>
                                                <IconButton>
                                                    <EditIcon style={{ color: 'blueviolet' }} />
                                                </IconButton>
                                            </Link>
                                        )}

                                        {hasDeleteAdministrationPermission && (
                                            <IconButton onClick={() => (member.IsActive ? openConfirmDialog(member.Id) : handleActivate(member.Id))}>
                                                {member.IsActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="cancelbutton">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="confirmbutton">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default AdministrationIndex;

